/**
 * blogLoaders: a post's page answers as an address that does not exist when
 * @gearghost/blog holds no post at it, so a mistyped or old address shows
 * the layout's Page Not Found (RouteErrorBoundary), as the Sales Tax guide
 * does while its switch is off.
 *
 * The posts are imported when the loader runs, never at the top of this
 * file: the route loaders ride in the site's first script, which every
 * visitor downloads, and the posts' text belongs to the blog's pages alone.
 */
import type { LoaderFunctionArgs } from 'react-router'
import { importWithRetry } from '@/navigation/utils/lazyRoute'
import { notFound } from '@/navigation/loaders/notFound'

export const blogPostLoader = async ({ params }: Pick<LoaderFunctionArgs, 'params'>) => {
  const { postAt } = await importWithRetry(() => import('@gearghost/blog/bundled'))
  if (postAt(params.slug) === undefined) throw notFound()
  return null
}
